
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPistonClosedLeft as ObiTwowayAcuatorPistonClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-closed-left.js';
 
 
 

 
 export const ObiTwowayAcuatorPistonClosedLeft = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-closed-left',
   elementClass: ObiTwowayAcuatorPistonClosedLeftElement,
   events: {
     
   }
  });
 
 